import { render, staticRenderFns } from "./OrganizationUsersPage.vue?vue&type=template&id=6c7a8e53&scoped=true&"
import script from "./OrganizationUsersPage.vue?vue&type=script&lang=ts&"
export * from "./OrganizationUsersPage.vue?vue&type=script&lang=ts&"
import style0 from "./OrganizationUsersPage.vue?vue&type=style&index=0&id=6c7a8e53&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c7a8e53",
  null
  
)

export default component.exports